import { Company, COMPANIES_SEARCH_MAX_PAGE_SIZE } from 'models'
import { useGetCompanies } from './useGetCompanies'

type UseGetChildrenCompaniesOptions = {
  search?: string
}

const useGetChildrenCompanies = (
  parentCompany: Company | null,
  options?: UseGetChildrenCompaniesOptions,
) => {
  const { id: parentId } = parentCompany || {}

  const query = useGetCompanies(
    parentId
      ? {
          parentId,
          sort: [{ field: 'name', direction: 'asc' }],
          paging: { page: 1, pageSize: COMPANIES_SEARCH_MAX_PAGE_SIZE },
          ...(options?.search ? { name: { contains: options.search } } : {}),
        }
      : undefined,
    { enabled: Boolean(parentId) },
  )

  return parentId
    ? query
    : {
        data: [],
        isLoading: false,
        isFetching: false,
        isError: false,
        hasData: false,
        isSuccess: false,
      }
}

export { useGetChildrenCompanies }
